<template>
    <div class="tab">
        <div class="tab_switch tab_switch_w">
          <p 
            v-for="(item, index) in tabData"
            :key="index"
            @click="swicthTab(item)"
            :class="[index +1=== Number(activeName) ? 'actived': '']"
          >{{item.label}}</p>
        </div>
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
                v-for="(item, index) in tabData"
                :key="index"
                :label="item.label"
                :name="item.name"
                >    
            </el-tab-pane>
        </el-tabs> -->
        <Report
            class="tabReport"
            v-if="tabItemData.type === 'list'"
            :key="tabItemData.path"
            :tab="tabItemData.path"
        ></Report>
        <component v-else :is="tabItemData.componentName"></component>
    </div>
</template>
<script>
// import axios from 'axios'
import { getTabConfig } from '@/api/common.js'
import Report from '../config/index.vue'
import Test from '@/_app/app/src/views/test.vue'
import distributorBaseInfo from '@/_app/outlet/src/views/distributorBaseInfo/index.vue'
import memberBaseInfo from '@/_app/outlet/src/views/memberBaseInfo/index.vue'
export default {
  data() {
    return {
      'message': '测试tab',
      'tabData': [],
      'activeName': '1',
      'componentName': '',
      'tabItemData': {}
    }
  },
  components: {
    Report,
    Test,
    distributorBaseInfo,
    memberBaseInfo
  },
  created() {
    getTabConfig(this.$route.params.path).then((res) => {
      if (res.code === 0) {
        this.tabData = res.data.tab
        this.filterTabData()
      }
    })
    // axios({
    //   method: 'GET',
    //   url: this.$route.params.path,
    //   params: {}
    // }).then((res) => {
    //   if (res.data.code === 0) {
    //     this.tabData = res.data.data.tab
    //     this.filterTabData()
    //   }
    // })
  },
  methods: {
    // handleClick(tab, event) {
    //   this.filterTabData()
    // },
    swicthTab(item) {
      this.activeName = item.name
      this.filterTabData()
    },
    filterTabData() {
      const tabItemData = this.tabData.filter((item, index) => {
        return item.name === this.activeName
      })
      this.tabItemData = tabItemData[0]
    }
  }
}
</script>
<style lang="scss" scoped>
  .tab {
    display: flex;
    flex:1;
    flex-direction: column;
    .tabReport {
      flex: 1;
      display: flex;
    }
  }

</style>

<style>
    .tab .report-header .report-button-warpper {
      overflow: auto
    }
</style>





// WEBPACK FOOTER //
// src/views/config/tab.vue